document.addEventListener("DOMContentLoaded", function () {
  const transitionDuration = 4000; // Convert seconds to milliseconds

  // Get all desktop and mobile images
  const desktopImages = document.querySelectorAll('.disappearing-banner__image--desktop');
  const mobileImages = document.querySelectorAll('.disappearing-banner__image--mobile');

  // For desktop images: fade out the first one and show the second one
  if (desktopImages.length >= 2) {
    setTimeout(() => {
      desktopImages[0].style.opacity = '0'; // Fade out the first desktop image
      desktopImages[0].style.transition = `opacity ${transitionDuration / 1000}s ease-out`; // Smooth transition

      desktopImages[1].style.opacity = '1'; // Fade in the second desktop image
      desktopImages[1].style.transition = `opacity ${transitionDuration / 1000}s ease-out`; // Smooth transition
    }, 0); // Start the fade-out immediately
  }

  // For mobile images: fade out the first one and show the second one
  if (mobileImages.length >= 2) {
    setTimeout(() => {
      mobileImages[0].style.opacity = '0'; // Fade out the first mobile image
      mobileImages[0].style.transition = `opacity ${transitionDuration / 1000}s ease-out`; // Smooth transition

      mobileImages[1].style.opacity = '1'; // Fade in the second mobile image
      mobileImages[1].style.transition = `opacity ${transitionDuration / 1000}s ease-out`; // Smooth transition
    }, 0); // Start the fade-out immediately
  }
});